import React from 'react';
import { useTranslation } from 'react-i18next';


import { Icon } from '@uncinc/uncinc-react-kitchen-sink';
import { CoreLink } from '@uncinc/react-drupal-core';

import './style.scss';

const SocialMenu = ({ colorClass = 'black', showHeader = true }) => {
  const { t } = useTranslation();

  return (
    <div className="SocialMenu">
      {showHeader && (
        <h4 className="SocialMenu__title">{t('general.socials')}</h4>
      )}
      <CoreLink title="LinkedIn" href="https://nl.linkedin.com/company/unc-inc" className={`SocialMenu__icon ${colorClass}`}>
        <Icon name="linkedin" />
      </CoreLink>
      <CoreLink title="Instagram" href="https://www.instagram.com/unc_inc" className={`SocialMenu__icon ${colorClass}`}>
        <Icon name="instagram" />
      </CoreLink>
    </div>
  );
};

export default SocialMenu;
